export type SeasonalThemeId = 'halloween' | 'christmas';

export interface MonthDay {
	/** 1 = janvier … 12 = décembre */
	month: number;
	day: number;
}

export interface SeasonalThemeConfig {
	id: SeasonalThemeId;
	enabled: boolean;
	/** Début de la période (inclus), chaque année. */
	start: MonthDay;
	/** Fin de la période (incluse). Peut être « avant » le début : la période passe alors le Nouvel An. */
	end: MonthDay;
}

/**
 * Périodes d'activation des thèmes saisonniers. Se répètent chaque année.
 * Si deux périodes se chevauchent, la première de la liste l'emporte.
 */
export const SEASONAL_THEMES: readonly SeasonalThemeConfig[] = [
	{
		id: 'halloween',
		enabled: true,
		start: {month: 10, day: 15},
		end: {month: 11, day: 2},
	},
	{
		id: 'christmas',
		enabled: true,
		start: {month: 12, day: 1},
		end: {month: 1, day: 6},
	},
];

/**
 * Force un thème quel que soit le jour (tests, démo), ou `'none'` pour tout désactiver.
 * `null` = comportement normal, selon les dates ci-dessus.
 * Aperçu sans modifier ce fichier : ajouter `?season=halloween` (ou `christmas` / `none`) à l'URL.
 */
export const SEASONAL_THEME_OVERRIDE: SeasonalThemeId | 'none' | null = null;
